export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGIN_RESPONSE = 'USER_LOGIN_RESPONSE';
export const USER_LOGOUT = 'USER_LOGOUT';